import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useEnter } from "@/lib/motion";

// Top of a service page (25:11 and siblings): an orange block with the
// service name, tagline, description paragraphs, white CTA, and the fox ears
// peeking from the bottom right.
export const ServiceHero = ({ service }) => {
    const reveal = useEnter();

    return (
        <section className="relative overflow-hidden bg-brand">
            <div className="relative mx-auto min-h-[580px] md:min-h-[640px] max-w-[1440px] px-6 pb-[80px] pt-[110px] md:px-[90px] md:pb-[90px] md:pt-[130px]">
                <div className="max-w-[700px] z-20 relative">
                    <motion.h1
                        className="type-display text-[clamp(48px,6.5vw,92px)] leading-[0.95] text-paper"
                        {...reveal()}
                    >
                        {service.name}
                    </motion.h1>

                    {service.tagline && (
                        <motion.p
                            className="mt-6 text-[clamp(19px,1.8vw,26px)] font-bold italic text-paper"
                            {...reveal(0.08)}
                        >
                            {service.tagline}
                        </motion.p>
                    )}

                    {service.body && (
                        <motion.div
                            className="mt-6 space-y-4 text-[clamp(16px,1.4vw,20px)] leading-relaxed text-paper/95"
                            {...reveal(0.12)}
                        >
                            {service.body.map((paragraph) => (
                                <p key={paragraph}>{paragraph}</p>
                            ))}
                        </motion.div>
                    )}

                    <motion.div className="mt-8" {...reveal(0.18)}>
                        <Link
                            to="/contato"
                            className="type-display inline-flex h-[52px] w-[190px] items-center justify-center bg-paper text-[20px] md:text-[22px] font-bold text-brand shadow-sm transition-transform duration-200 hover:scale-105 active:scale-95 btn-sweep [--sweep:theme(colors.brand.DEFAULT/12%)]"
                        >
                            INICIAR PROJETO
                        </Link>
                    </motion.div>
                </div>

                {/* Fox Ears peeking from the bottom right */}
                <motion.img
                    src="/images/brand/orelhas.png"
                    alt=""
                    aria-hidden
                    className="pointer-events-none absolute bottom-0 right-[-40px] w-[380px] select-none object-contain sm:right-[-25px] sm:w-[520px] md:right-[-20px] md:w-[680px] lg:right-[-15px] lg:w-[840px] xl:right-[-10px] xl:w-[920px] z-10"
                    initial={{ y: 70, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
                />
            </div>
        </section>
    );
};
